import { MetadataPlugin } from "./metadata";

export const createRestrictedPlugin: MetadataPlugin<boolean> =
  function () {
    function getValue() {
      return {
        restricted: true,
      };
    }

    return {
      getValue,
    };
  };
